import { safeLink } from '../format';

function Inline({ text }: { text: string }) {
  const pieces = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^)]+\))/g).filter(Boolean);
  return (
    <>
      {pieces.map((piece, index) => {
        const link = piece.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (link) {
          const href = safeLink(link[2]);
          return href ? (
            <a key={index} href={href} rel="noreferrer">
              {link[1]}
            </a>
          ) : (
            <span key={index}>{link[1]}</span>
          );
        }
        if (piece.startsWith('**') && piece.endsWith('**'))
          return <strong key={index}>{piece.slice(2, -2)}</strong>;
        if (piece.startsWith('*') && piece.endsWith('*'))
          return <em key={index}>{piece.slice(1, -1)}</em>;
        return <span key={index}>{piece}</span>;
      })}
    </>
  );
}

export function SafeContent({ body }: { body: string }) {
  const lines = body.split('\n');
  const nodes: React.ReactNode[] = [];
  let list: string[] = [];
  const flush = () => {
    if (list.length)
      nodes.push(
        <ul key={`list-${nodes.length}`}>
          {list.map((item, i) => (
            <li key={i}>
              <Inline text={item} />
            </li>
          ))}
        </ul>,
      );
    list = [];
  };
  lines.forEach((line) => {
    if (line.startsWith('- ')) {
      list.push(line.slice(2));
      return;
    }
    flush();
    if (!line.trim()) return;
    if (line.startsWith('## '))
      nodes.push(
        <h2 key={nodes.length}>
          <Inline text={line.slice(3)} />
        </h2>,
      );
    else
      nodes.push(
        <p key={nodes.length}>
          <Inline text={line} />
        </p>,
      );
  });
  flush();
  return <div className="safe-content">{nodes}</div>;
}
